import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Clarity from '@microsoft/clarity';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './src/styles/global.css';
import './src/styles/responsive.css';

Clarity.init('st5l68r71v');
const queryClient = new QueryClient();

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>{element}</QueryClientProvider>
  );
};
